<template>
    <div class="table-responsive overflow-hidden border border-gray-300 rounded-md">
        <div class="flex-row items-center">
            <div class="bg-color-items flex-column w-1/12 py-2 px-2 font-bold">ID</div>
            <div class="bg-color-items flex-column w-2/12 py-2 px-2 font-bold">Время</div>
            <div class="bg-color-items flex-column w-2/12 py-2 font-bold">Консьерж</div>
            <div class="bg-color-items flex-column w-2/12 py-2 px-2 font-bold">Башня</div>
            <div class="bg-color-items flex-column w-2/12 py-2 px-2 font-bold">Этаж</div>
            <div class="bg-color-items flex-column w-2/12 py-2 px-2 font-bold">Апартаменты</div>
            <div class="bg-color-items flex-column w-2/12 py-2 px-2 font-bold">Тип доставки</div>
        </div>

        <div
            v-for="item in list"
            :key="item.id"
            class="flex-row items-center h-10 py-4 border-t border-gray-300 table-responsive-item"
        >
            <div class="flex-column w-1/12 truncate px-2">
                <span
                    class="text-purple-700 cursor-pointer hover:underline"
                    :title="item.id"
                    @click="$emit('select', item.id)"
                >
                    {{ item.id }}
                </span>
            </div>
            <div class="flex-column w-2/12 px-2">
                {{ getTime(item.created_at) }}
            </div>
            <div class="flex-column w-2/12 px-2">
                <span
                    class="text-purple-700 cursor-pointer hover:underline"
                    :title="getConcierge(item.concierge_id)"
                    @click="$router.push(`/concierges/${item.concierge_id}`)"
                >
                    {{ getConcierge(item.concierge_id) }}
                </span>
            </div>
            <div class="flex-column w-2/12 px-2">
                {{ getTowers(item.tower_id) }}
            </div>

            <div class="flex-column w-2/12 truncate px-2">
                {{ item.floor }}
            </div>
            <div class="flex-column w-2/12 truncate px-2">
                {{ item.appartment }}
            </div>
            <div class="flex-column w-2/12 truncate px-2">
                {{ item.delivery_type }}
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    const moment = require('moment');

    export default {
        props: {
            list: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({
            towers: [],
            concierges: [],
        }),

        async mounted() {
            try {
                const { data: towers } = await Vue.axios.get('/address');
                this.towers = towers;

                const { data: concierges } =  await Vue.axios.get('/concierges');
                this.concierges = concierges.results;
            } catch (err) {
                this.$root.$emit('showError', 'Ошибка загрузки данных. ' + err);
            }
        },

        methods: {
            getTowers(id) {
                if (this.towers?.length > 0) {
                    const tower = this.towers.find(t => t?.id === id);
                    if (tower?.id) {
                        return tower.address;
                    } 
                    return '';
                }
                return '';
            },
            getConcierge(id) {
                if (this.concierges?.length > 0) {
                    const concierge = this.concierges.find(t => t?.id === id);
                    if (concierge?.id) {
                        return concierge.name;
                    } 
                    return '';
                }
                return '';
            },
            getTime(time) {
                return moment(time).format('YYYY-MM-DD HH:mm:ss');
            }
        },
    };
</script>
<style scoped>
    .table-responsive {
        display: block;
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
    }

    .flex-row {
        display: flex;
        min-width: auto;
    }

@media (max-width: 767px) {
    .flex-column {
        flex: 0 0 auto; 
        padding: 10px;
        min-width: 120px;
    }
}

@media (min-width: 767px) {
    .flex-column {
        flex: 0 0 auto; 
        padding: 10px;
        min-width: 100px;
    }
}

    .bg-color-items {
        background-color: #e2e8f0;
        color: #3c4b64
    }
</style>